<template>
    <b-modal id="bv-modal-count-down"
            @hide="onHide"
             :hide-footer="true"
             :no-close-on-esc="true"
             :no-close-on-backdrop="true"
             :hide-header-close="true"
             ref="modal"
    >
        <template v-slot:modal-title>
            {{title}}
        </template>


        <div class="d-block pb-3">
            {{messageReplaced}}<br/>
        </div>

      <div class="d-block text-center pb-3 pt-4">
        <b-button :disabled="!buttonEnabled"  size="md" class="my-2 my-sm-0" variant="plm-action" @click="hide()" > {{buttonLabelReplaced}} </b-button>
      </div>


    </b-modal>

</template>

<script>
    export default {
        name: "Countdown",
        async beforeMount() {
        },
        methods: {
            hide(){
               this.$refs.modal.hide();
               this.stopped = true;
            },
            async onHide(ev){
                if(this.resolve != null){
                    this.resolve(null);
                    this.resolve = null;
                }
            },
            reset(){
                this.resolve = null;
                this.messageReplaced = "";
                this.buttonLabelReplaced = "OK";
                this.buttonEnabled = false;
                this.stopped = false;
            },
            enableButton(){
                this.buttonEnabled = true;
            },
            startCountDown(ctr, enableButtonAfter){
              let msg = this.message;
              let btn = this.buttonLabel;
              this.messageReplaced = msg.replace("${countDown}", ctr);
              this.buttonLabelReplaced = btn.replace("${countDown}", ctr);
              let seconds = 0;
              let decrement = () => {
                if(this.stopped) {
                  return;
                }
                if(ctr > 0){
                    ctr--;
                    this.messageReplaced = msg.replace("${countDown}", ctr);
                    this.buttonLabelReplaced = btn.replace("${countDown}", ctr);
                    if(enableButtonAfter >=0 && seconds >= enableButtonAfter){
                        this.buttonEnabled = true;
                    }
                    seconds++;
                    setTimeout(decrement, 1000);
                } else {
                    this.hide();
                }
              };
              setTimeout(decrement, 1000);
            }
        },
        data: () => ({
            title:"title",
            resolve: null,
            buttonLabel:"",
            message:"message",
            buttonLabelReplaced:"",
            messageReplaced:"message",
            buttonEnabled:false,
            stopped:false
        })
    }
</script>
